import Gap from '~/components/Gap';
import Text from '~/components/Text';
import * as Styles from './styles';
import { ISectionProps } from './types';
import LogoUpload from '../AddInvoice/InvoiceForm/LogoUpload';
import { useIsDesktop } from '~/hooks/useIsDesktop';

const LogoSection = ({ business, onChange }: ISectionProps) => {
  const isDesktop = useIsDesktop();
  return (
    <Styles.Section>
      <Styles.SectionDesc>
        <Text className={isDesktop ? 'bold' : ''} size={isDesktop ? 'sm' : 'ssmd'}>
          Company logo
        </Text>
        <Gap t={4} />
        <Text size="xs" variant="neutral">
          Update your company logo
        </Text>
      </Styles.SectionDesc>
      <Gap r={40} />

      <div>
        <LogoUpload
          preImageUrl={business.logo_url}
          setValue={({ logoUrl }) => {
            onChange({ logo_url: logoUrl });
          }}
        />
      </div>
    </Styles.Section>
  );
};

export default LogoSection;
